import axios from 'axios'
import { message } from 'ant-design-vue'

let entryUrl = ''
let entryMap = {
  localhost: 'https://lab.dev.iol8.net',
  dev: 'https://lab.dev.iol8.net',
  qa: 'https://lab.qa.iol8.net',
  release: 'https://lab.release.iol8.net',
  'iol8.com': 'https://lab.iol8.com',
}
for (let key in entryMap) {
  if (location.origin.includes(key)) {
    entryUrl = entryMap[key]
  }
}

// 创建axios实例
const service = axios.create({
  baseURL: window.__POWERED_BY_QIANKUN__ ? `${entryUrl}/api` : '/api',
  timeout: 30000000, // 请求超时时间
  headers: { 'Content-Type': 'application/json;charset=UTF-8' },
  withCredentials: false, // 凭证
})

// request拦截器
service.interceptors.request.use(
  (config) => {
    if (localStorage.token) {
      config.headers['Authorization'] = 'Bearer ' + localStorage.token
    }
    return config
  },
  (err) => {
    // 接口请求出错可在此处统一处理
    return Promise.reject(err)
  }
)

// respone拦截器
service.interceptors.response.use(
  (data) => {
    // 数据统一校验处理
    const res = data
    if (res.status == 200) {
      return res.data
    }
    // 非200状态码：返回 rejection 让调用方处理
    return Promise.reject(new Error(`请求失败，状态码: ${res.status}`))
  },
  (err) => {
    // 网络错误时 err.response 可能为 undefined（DNS失败/超时/CORS等）
    const _response = err.response?.data
    if (!_response) {
      message.error('网络异常，请检查网络连接后重试')
      return Promise.reject(err)
    }
    const _code = _response.code
    const _reason = _response.reason
    if (_code == 400 && (_reason == 'QUOTA_LIMIT' || _reason == 'TERM_NAME')) {
      // 不做处理
    } else if (_code == 401 && !location.origin.includes('localhost')) {
      //token失效或未登录
      localStorage.token = ''

      let url = encodeURIComponent(window.location.href)
      window.location.href = '/go/passport_pc/cas/login?service=' + url
    } else if (_code == 409) {
      window.location.href = `/go/pe_pc_login/selectEnterprise`
    } else {
      message.error(_response.message || '服务器或网络异常，请稍后重试')
    }
    return Promise.reject(err)
  }
)

export default service
